import PropTypes from "prop-types";
import React from "react";

import { usePlacementIds } from "@swa-ui/placements";

import { SpecialOffersCard } from "../SpecialOffersCard";

export const SpecialOffersSection = (props) => {
  const { placement } = props;
  const placementIds = usePlacementIds(new RegExp(`${placement?.id}.*`));

  return placementIds.length > 0 && <SpecialOffersCard placementIds={placementIds} />;
};

SpecialOffersSection.propTypes = {
  /** Object that displays placement content. */
  placement: PropTypes.object,
};
